import * as React from "react";
import { CalendarIcon, IconComponent, StoreIcon, Tab, Tabs, TabsLayout } from "../../ui";
import { PartsGrouping } from "../partsStatus.utils";

const options: { key: PartsGrouping; label: string; Icon: IconComponent }[] = [
  { key: "STORE", label: "By store", Icon: StoreIcon },
  { key: "JOB", label: "By job", Icon: CalendarIcon },
];

/**
 * How the list is grouped. Store is the default and stays the default — it is the unit
 * of work for a pickup run; grouping by job is for when you are standing at the job.
 */
export const PartsGroupingTabs: React.FC<{
  value: PartsGrouping;
  onChange: (next: PartsGrouping) => void;
}> = ({ value, onChange }) => (
  <Tabs
    value={value}
    onChange={onChange}
    layout={TabsLayout.FULL_WIDTH}
    aria-label="Group part orders"
    // Shorter than the filter tabs above: this is a secondary control, and the sticky
    // header already carries a toolbar and a tab row.
    style={{ minHeight: "2.125rem" }}
  >
    {options.map((option) => (
      <Tab
        key={option.key}
        value={option.key}
        label={
          <span className="flex items-center justify-center gap-1 whitespace-nowrap">
            <option.Icon style={{ fontSize: "0.9375rem", flexShrink: 0 }} />
            {option.label}
          </span>
        }
        // Same size as the filter row above — below 12 is unreadable on a phone. This
        // row stays secondary through weight, not by being smaller.
        style={{ minHeight: "2.125rem", fontSize: "0.75rem", minWidth: 0, textTransform: "none" }}
      />
    ))}
  </Tabs>
);
